import React, { useState, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Header from "../components/Header";
import "../styles/ResultPage.css";
import { PersonaContext } from "../context/PersonaContext";
import SummaryTable from "../components/SummaryTable";
import HelpTooltip from "../components/HelpTooltip";
import { exportToCsv, exportToJson, exportToPdf } from "../services/export";

const ResultPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { personaData } = location.state;

  const processString = (response) => {
    if (response.includes("They")) {
      let modifiedResponse = response
        .replace(/\bhas\b/g, "have")
        .replace(/\bdoes\b/g, "do")
        .replace(/\bdoesn't\b/g, "don't");

      let isCount = 0;
      modifiedResponse = modifiedResponse.replace(/\bis\b/g, (match) => {
        isCount++;
        return isCount > 1 ? "are" : match;
      });

      return modifiedResponse;
    }
    return response;
  };

  Object.keys(personaData.personas).map((ethnicity) => {
    personaData.personas[ethnicity].map((persona) => {
      persona["persona_characteristics"] = processString(
        persona["persona_characteristics"]
      );
    });
  });
  const { resetState } = useContext(PersonaContext);
  const [exportEnabled] = useState({ json: true, csv: true, pdf: true });
  const [visiblePersonas, setVisiblePersonas] = useState({});

  const toggleShowMore = (ethnicity) => {
    setVisiblePersonas((prevState) => ({
      ...prevState,
      [ethnicity]:
        prevState[ethnicity] === personaData.personas[ethnicity].length
          ? 3
          : personaData.personas[ethnicity].length,
    }));
  };

  const handleCreatePersonaClick = () => {
    const confirmResubmission = window.confirm(
      "Are you sure to proceed? Your personas will be lost if you haven't exported it."
    );
    if (confirmResubmission) {
      resetState();
      navigate("/location");
    }
  };

  const handleExport = (format) => {
    if (format === "json" && exportEnabled.json) {
      exportToJson(personaData);
    } else if (format === "pdf" && exportEnabled.pdf) {
      exportToPdf(personaData);
    } else if (format === "csv" && exportEnabled.pdf) {
      exportToCsv(personaData);
    }
  };

  /*const getCurrentDateTime = () => {
        const today = new Date();
        
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        const hours = String(today.getHours()).padStart(2, '0');
        const minutes = String(today.getMinutes()).padStart(2, '0');
      
        const formattedDateTime = `${year}-${month}-${day}-${hours}:${minutes}`;
        
        return formattedDateTime;
    }

    const exportToCsv = (data) => {
        const zip = new JSZip();
        const currentTime = new Date().toISOString().slice(0, 16).replace(/[-T:]/g, '');
        const personaCsvFilename = `personas_${currentTime}.csv`;
        const personaCsvHeaders = ["Ethnicity", "Persona ID", "Percent Similar", "Persona Characteristics"];
    
        let personaCsvContent = personaCsvHeaders.join(',') + '\n';
        for (const [ethnicity, personas] of Object.entries(data.personas)) {
            personas.forEach(persona => {
                personaCsvContent += `${ethnicity},${persona.persona_ID},${persona.percentage_similar_respondants},${persona.persona_characteristics}\n`;
            });
            }

    
        zip.file(personaCsvFilename, personaCsvContent);

        const parametersCsvFilename = `personas_${currentTime}_parameters.csv`;
        const parametersCsvHeaders = ["Timestamp", "Location Selected", "Sectors Selected", "Topics Selected", "Dataset Used", "Ethnicity Selected"];
    
        const timestamp = getCurrentDateTime();
        const locationSelected = `"${data.location.join(", ")}"`;

        const sectorsSelected = `"${Object.keys(data.topics).join("| ")}"`;
    
        const topicsSelected = `"${Object.entries(data.topics)
        .map(([sector, topics]) => topics.map(topic => `${topic.topic}`).join("; "))}"`
      
    
        const datasetUsed = data.dataset;
        const ethnicitySelected = `"${data.ethnicity.join(", ")}"`;

        const parametersCsvContent = [
        parametersCsvHeaders.join(','), // Add headers
      `${timestamp},${locationSelected},${sectorsSelected},${topicsSelected},${datasetUsed},${ethnicitySelected}` // Add data
         ].join('\n');


        zip.file(parametersCsvFilename, parametersCsvContent);

        zip.generateAsync({ type: 'blob' }).then(content => {
        saveAs(content, `personas_${currentTime}.zip`);
        });
    };

    
    const exportToJson = (data) => {
        const jsonString = JSON.stringify(data, null, 2);
        const currentTime = new Date().toISOString().slice(0, 16).replace(/[-T:]/g, '');
        const blob = new Blob([jsonString], { type: 'application/json' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `personas_${currentTime}.json`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };

    const exportToPdf = (data) => {
        const doc = new jsPDF("p", "mm", "a4");
        const pageWidth = 210;
        const headerHeight = 20;
        doc.setFillColor(0, 86, 179);
        doc.rect(0, 0, pageWidth, headerHeight, "F");


        const img1 = new Image();
        img1.src = personaCreator;
        doc.addImage(img1, "PNG", 10, 5, 30, 9);

        
        const img2 = new Image();
        img2.src = prime;
        doc.addImage(img2, "PNG",100, 5, 30, 9);
        const img3 = new Image();
        img3.src = hwu;
        doc.addImage(img3, "PNG", 130, -10, 40, 38);
        const img4 = new Image();
        img4.src = ukri;
        doc.addImage(img4, "PNG", 170, 5, 30, 9);

        const headerText = "PERSONA DATA SUMMARY";
        doc.setFont("helvetica", "bold");
        doc.setFontSize(18);
        const headerTextWidth = doc.getTextWidth(headerText);
        doc.text(headerText, (pageWidth - headerTextWidth) / 2, 130);

        
        doc.setFontSize(8);
        
        const pageHeight = doc.internal.pageSize.getHeight();
        doc.text("Generated on: ", 10, pageHeight - 70);
        doc.text("App Version: ", 10, pageHeight - 60);
        doc.text("App link: ", 10, pageHeight - 50);
        doc.text("PRIME website: ", 10, pageHeight - 40);
        doc.text("Contact: ", 10, pageHeight - 30);

        doc.setFont("helvetica", "normal");
        doc.text(getCurrentDateTime(), 30, pageHeight - 70);
        doc.text("v1", 28, pageHeight - 60);
        doc.text("https://dependent-pheasant-primepersonacreator-ef609594.koyeb.app/", 23, pageHeight - 50);
        doc.text("https://www.primecommunities.online/", 32, pageHeight - 40);
        doc.text("as2453@hw.ac.uk", 22, pageHeight - 30);

        doc.addPage();
        doc.setFont("helvetica", "bold");
        doc.setFontSize(18);
        doc.text("Introduction", 14, 15);
        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);
        
        const personaText = `
        The PersonaCreator app is part of the PRIME (Protecting Minority Ethnic Communities Online) project. It uses machine learning techniques on data collected in PRIME's own survey as well as data from other public surveys, to create personas of people from Minority Ethnic Communities. These personas depict how people from these communities feel or experience various online harms, discrimination and bias while using digital services related to Health, Energy, and Social Housing.
        
        PersonaCreator has been developed with the aim to provide various stakeholders of digital services related to Health, Energy, and Social Housing a better understanding of the needs and concerns of different minority ethnic groups as well as hidden sub-groups within broad ethnic groups in England and Scotland.
        
        With PersonaCreator, you will be able to select which surveys you want to use to create such personas. Specify which ethnic groups and nations you want these personas to belong to and which specific topics you want to focus on. The created personas can also be downloaded in various formats for later reflection and discussion.
        `;

        doc.setFontSize(11);

        const maxWidth = 180;

        var wrappedText = doc.splitTextToSize(personaText, maxWidth);

        doc.text(wrappedText, 15, 30);

        doc.addPage();
        const checkPageOverflow = (doc, yPosition, marginBottom = 30) => {
            const pageHeight = doc.internal.pageSize.getHeight();
            if (yPosition + marginBottom >= pageHeight) {
            doc.addPage();
            return 20;
            }
            return yPosition;
        };
    
        
        doc.setFont("helvetica", "bold");
        doc.setFontSize(16);
        doc.text("Parameters used", 15, 20);
        doc.setFontSize(12);
        let y = 30;
    
        
        doc.setFont("helvetica", "bold");
        doc.text("Dataset: ", 15, y);
        doc.setFont("helvetica", "normal");
        doc.setFontSize(11);
        doc.text(data.dataset, 33, y);
        y += 7;
    
        
        const descriptionLines = doc.splitTextToSize(data.dataset_description, 180);
        doc.text(descriptionLines, 15, y);
        y += descriptionLines.length * 5;
    
        
        doc.setFont("helvetica", "bold");
        doc.text("Location: ", 15, y);
        doc.setFont("helvetica", "normal");
        doc.text(data.location.join(", "), 34, y);
        y += 7;
    
        
        doc.setFont("helvetica", "bold");
        doc.text("Ethnicity: ", 15, y);
        doc.setFont("helvetica", "normal");
        doc.text(data.ethnicity.join(", "), 35, y);
        y += 10;
    
        
        doc.setFont("helvetica", "bold");
        doc.text("Questions:", 15, y);
        y += 10;
        
        
        for (const [key, value] of Object.entries(data.topics)) {
            
            y = checkPageOverflow(doc, y);
            doc.setFont("helvetica", "bold");
            doc.text(key, 15, y);
            y += 10;
    
            
            value.forEach((item, index) => {
            y = checkPageOverflow(doc, y);
            doc.setFont("helvetica", "bold");
            doc.text(index+1+". "+item.topic, 15, y);
            y += 7;
    
            doc.setFont("helvetica", "normal");
            doc.setFont("helvetica", "italic");
            doc.text("Question asked in the survey: ", 15, y);
            doc.setFont("helvetica", "normal");
            const questionLines = doc.splitTextToSize(item.question, 180);
            doc.text(questionLines, 15, y + 7);
            y += questionLines.length * 7 + 10;
    
            y = checkPageOverflow(doc, y);
            });
        }

        doc.setFont("helvetica", "bold");
        const disclaimerLine = doc.splitTextToSize("*The count and order of genders and names used in the personas are randomised and are not based on the selected datasets.", 180);
        doc.text(disclaimerLine, 15, y);

        doc.setFont("helvetica", "normal");
        
            Object.keys(data.personas).forEach((ethnicity) => {
                doc.addPage();
                doc.setFont("helvetica", "bold");
                doc.text(`Ethnicity: ${ethnicity}`, 14, 15);

                doc.setFont("helvetica", "normal");
                const ethnicitygrouptext = doc.splitTextToSize(`(${personaData.ethnicity_grouping[ethnicity]})`, 180);
                doc.text(ethnicitygrouptext, 14, 19)
                

                const tableData = data.personas[ethnicity].map((persona, index) => [
                    `Persona ${index + 1}`,
                    persona.persona_characteristics,
                    `${(persona.percentage_similar_respondants * 100).toFixed(2)}%`
                ]);

                
                doc.autoTable({
                    head: [['Persona', 'Characteristics', 'Percentage']],
                    body: tableData,
                    startY: 24,
                    styles: { fontSize: 8, cellPadding: 2, overflow: 'linebreak' },
                    theme: 'grid'
                });
            });

            const totalPages = doc.internal.getNumberOfPages();


            for (let i = 1; i <= totalPages; i++) {
                doc.setPage(i);
        
                doc.setFontSize(10);
                doc.setFont("helvetica", "normal");
                doc.textWithLink("https://www.primecommunities.online/", 15, doc.internal.pageSize.getHeight() - 10, {
                url: "https://primecommunities.online",
                });
        
                doc.setFontSize(10);
                const pageWidth = doc.internal.pageSize.getWidth();
                doc.text(`Page ${i} of ${totalPages}`, pageWidth - 40, doc.internal.pageSize.getHeight() - 10); // Right side footer
            }

            const currentTime = new Date().toISOString().slice(0, 16).replace(/[-T:]/g, '');
            doc.save(`personas_${currentTime}.pdf`);
    };*/

  return (
    <div className="result-page">
      <Header />
      <h2 className="result-header">Persona Results</h2>
      <div className="persona-sections">
        {Object.keys(personaData.personas).map((ethnicity) => (
          <div key={ethnicity} className="ethnicity-section">
            <div style={{ display: "flex", alignItems: "center" }}>
              <h3>{ethnicity}</h3>
              <HelpTooltip
                sections={[
                  {
                    content: personaData.ethnicity_grouping[ethnicity],
                  },
                ]}
              />
            </div>

            <div className="persona-cards">
              {personaData.personas[ethnicity]
                .slice(0, visiblePersonas[ethnicity] || 3)
                .map((persona, index) => (
                  <div key={persona.persona_ID} className="persona-card">
                    <div className="persona-header">Persona {index + 1}</div>
                    <div className="persona-body">
                      {persona.persona_characteristics}
                    </div>
                    <div className="persona-footer">
                      Around{" "}
                      {Math.round(
                        persona.percentage_similar_respondants.toFixed(2)
                      )}
                      % of {ethnicity} respondents are similar
                    </div>
                  </div>
                ))}
            </div>
            {personaData.personas[ethnicity].length > 3 && (
              <div className="toggle-button-container">
                <button
                  className="toggle-button"
                  onClick={() => toggleShowMore(ethnicity)}
                >
                  {visiblePersonas[ethnicity] ===
                  personaData.personas[ethnicity].length
                    ? "Show Less"
                    : "Show More"}
                </button>
              </div>
            )}
            <br />
            <br />
          </div>
        ))}
      </div>
      <div className="summary-section">
        <SummaryTable data={personaData} />
        <h4>
          NB:The count and order of genders and names used in the personas are
          randomised and are not based on the selected datasets.
        </h4>
      </div>
      <div className="bottom-controls">
        <button onClick={() => navigate("/ethnicity")} className="back-button">
          Back
        </button>
        <button
          onClick={handleCreatePersonaClick}
          className="generate-again-button"
        >
          Generate Again
        </button>
        <div className="export-dropdown">
          <button className="export-button">Export ▲</button>
          <div className="dropdown-content">
            <button
              onClick={() => handleExport("json")}
              disabled={!exportEnabled.json}
              className={exportEnabled.json ? "enabled" : "disabled"}
            >
              Export as JSON
            </button>
            <button
              onClick={() => handleExport("csv")}
              disabled={!exportEnabled.csv}
              className={exportEnabled.csv ? "enabled" : "disabled"}
            >
              Export as CSV
            </button>
            <button
              onClick={() => handleExport("pdf")}
              disabled={!exportEnabled.pdf}
              className={exportEnabled.pdf ? "enabled" : "disabled"}
            >
              Export as PDF
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResultPage;
